import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';

import OpenExternallyIcon from '#/assets/OpenExternallyIcon';

import { cFFFFFF } from '#/colors';

import Link from '#/components/shared/Link';

import { useBuildStarknetTxUrl } from '#/features/starknet';

import { Nullable } from '#/utils/types';
import { ethereumTxUrl } from '#/utils/ethereum';
import maskString from '#/utils/maskString';

interface Props {
  readonly hash: Nullable<string>;
}

export function StarknetTxLink(props: Props) {
  const { hash } = props;
  const buildStarknetTxUrl = useBuildStarknetTxUrl();

  if (hash == null) return <NoTransaction />;

  return (
    <TxLink href={buildStarknetTxUrl(hash)}>{maskString(hash, 6, 4)}</TxLink>
  );
}

export function EthereumTxLink(props: Props) {
  const { hash } = props;

  if (hash == null) return <NoTransaction />;

  return <TxLink href={ethereumTxUrl(hash)}>{maskString(hash, 6, 4)}</TxLink>;
}

function TxLink({
  href,
  children,
}: PropsWithChildren<{ readonly href: string }>) {
  return (
    <ExternalLink href={href}>
      <span css="margin-right: 6px;">{children}</span>
      <OpenExternallyIcon size={9} />
    </ExternalLink>
  );
}

const ExternalLink = styled(Link).attrs({
  target: '_blank',
  rel: 'noopener',
})`
  svg {
    color: ${rgba(cFFFFFF, 0.5)};
    visibility: hidden;
  }

  &:hover svg {
    visibility: visible;
  }
`;

const NoTransaction = () => <span>-</span>;
